export interface Topic {
  id: string;
  title: string;
  summary: string;
  category: string;
  cover: string;
  tags: string[];
  heat: number;
  saved: number;
  date: string;
  source: string;
}

export const categories = [
  { key: "全部", icon: "ri-apps-2-line" },
  { key: "影视动态", icon: "ri-movie-2-line" },
  { key: "综艺热点", icon: "ri-live-line" },
  { key: "音乐现场", icon: "ri-music-2-line" },
  { key: "时尚潮流", icon: "ri-t-shirt-line" },
  { key: "网络热议", icon: "ri-fire-line" },
  { key: "明星行程", icon: "ri-map-pin-2-line" },
];

export const topics: Topic[] = [
  {
    id: "t01",
    title: "《长街灯火》收官口碑两极，观众到底在争论什么",
    summary:
      "这部剧用生活流叙事收尾，有人觉得克制真实，有人认为节奏偏慢。围绕结局的讨论持续升温，我们整理了几类最常见的观感。",
    category: "影视动态",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cream%20studio%20backdrop%20with%20abstract%20coral%20red%20geometric%20shapes%20and%20soft%20grain%20texture%2C%20minimal%20editorial%20magazine%20style%2C%20clean%20composition&width=800&height=600&seq=kanliao-topic-01&orientation=landscape",
    tags: ["剧集", "口碑", "收官"],
    heat: 9820,
    saved: 1284,
    date: "2026-09-11",
    source: "看料编辑部",
  },
  {
    id: "t02",
    title: "慢综艺回归：一档节目带火的小城旅行路线",
    summary:
      "节目没有强情节，却把一座小城的清晨与市集拍得很有烟火气。播出后当地民宿预订量明显上涨，路线也被观众整理成了攻略。",
    category: "综艺热点",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20amber%20and%20tea%20green%20abstract%20travel%20themed%20flat%20lay%20on%20cream%20background%2C%20soft%20natural%20light%2C%20editorial%20magazine%20aesthetic%2C%20clean%20minimal%20composition&width=800&height=600&seq=kanliao-topic-02&orientation=landscape",
    tags: ["综艺", "旅行", "小城"],
    heat: 8640,
    saved: 942,
    date: "2026-09-10",
    source: "看料编辑部",
  },
  {
    id: "t03",
    title: "露天音乐节穿搭图鉴：今年大家都在穿什么",
    summary:
      "从防晒披肩到复古工装，现场穿搭比舞台还热闹。我们按白天与夜场两个时段，整理了出现频率最高的几种搭配思路。",
    category: "音乐现场",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20terracotta%20and%20gold%20abstract%20music%20festival%20concept%20with%20soft%20bokeh%20circles%20on%20cream%20paper%20background%2C%20editorial%20minimal%20style&width=800&height=600&seq=kanliao-topic-03&orientation=landscape",
    tags: ["音乐节", "穿搭", "现场"],
    heat: 7420,
    saved: 786,
    date: "2026-09-10",
    source: "看料编辑部",
  },
  {
    id: "t04",
    title: "复古胶片风回潮，年轻人为什么开始用旧相机",
    summary:
      "颗粒感、偏色与等待冲扫的过程，反而成了吸引力。几位日常拍照的年轻人分享了他们重新拿起胶片机的原因与花费。",
    category: "时尚潮流",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cream%20background%20with%20abstract%20film%20grain%20texture%20and%20muted%20coral%20accent%20shapes%2C%20retro%20editorial%20magazine%20aesthetic%2C%20soft%20lighting&width=800&height=600&seq=kanliao-topic-04&orientation=landscape",
    tags: ["胶片", "摄影", "潮流"],
    heat: 6880,
    saved: 654,
    date: "2026-09-09",
    source: "看料编辑部",
  },
  {
    id: "t05",
    title: "「电子榨菜」现象：我们为什么吃饭一定要看点东西",
    summary:
      "一个人吃饭时打开一集熟悉的老剧，成了很多人的固定流程。这背后是习惯、陪伴感，还是单纯的注意力转移？我们聊了聊。",
    category: "网络热议",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20amber%20abstract%20concept%20of%20daily%20life%20objects%20flat%20lay%20on%20cream%20paper%2C%20soft%20shadows%2C%20minimal%20editorial%20magazine%20aesthetic&width=800&height=600&seq=kanliao-topic-05&orientation=landscape",
    tags: ["热议", "生活方式", "观察"],
    heat: 9310,
    saved: 1120,
    date: "2026-09-09",
    source: "看料编辑部",
  },
  {
    id: "t06",
    title: "剧组路透合集：三部新剧的造型提前曝光",
    summary:
      "片场照流出后，几套造型迅速被讨论。从年代感到现代都市，我们按剧集分类，看看哪些细节最容易被观众记住。",
    category: "明星行程",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20coral%20red%20abstract%20backstage%20concept%20with%20soft%20spotlight%20gradient%20on%20cream%20background%2C%20editorial%20minimal%20composition&width=800&height=600&seq=kanliao-topic-06&orientation=landscape",
    tags: ["路透", "造型", "新剧"],
    heat: 8090,
    saved: 833,
    date: "2026-09-08",
    source: "看料编辑部",
  },
  {
    id: "t07",
    title: "悬疑剧扎堆上线，观众最看重的是逻辑还是氛围",
    summary:
      "同期上线的几部悬疑剧风格差异明显。有人为推理细节买单，有人更在意画面氛围。我们对比了观众评分的主要分歧点。",
    category: "影视动态",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20deep%20amber%20and%20charcoal%20abstract%20mystery%20concept%20with%20soft%20light%20streaks%20on%20cream%20background%2C%20editorial%20minimal%20style&width=800&height=600&seq=kanliao-topic-07&orientation=landscape",
    tags: ["悬疑", "剧集", "评分"],
    heat: 7260,
    saved: 601,
    date: "2026-09-08",
    source: "看料编辑部",
  },
  {
    id: "t08",
    title: "竞技类综艺赛制升级，观众评分为什么反而回暖",
    summary:
      "新一季调整了组队与淘汰规则，节奏更紧凑。我们梳理了被提及最多的三处改动，以及它们对观感带来的实际影响。",
    category: "综艺热点",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20tea%20green%20and%20coral%20abstract%20competition%20concept%20with%20geometric%20blocks%20on%20cream%20paper%20background%2C%20editorial%20minimal%20aesthetic&width=800&height=600&seq=kanliao-topic-08&orientation=landscape",
    tags: ["综艺", "赛制", "评分"],
    heat: 6540,
    saved: 512,
    date: "2026-09-07",
    source: "看料编辑部",
  },
  {
    id: "t09",
    title: "独立乐队巡演地图：一票难求的现场到底好在哪",
    summary:
      "小型 livehouse 的现场感是很多乐迷坚持的理由。我们跟着一场巡演，记录了从开票到散场的完整体验。",
    category: "音乐现场",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20amber%20abstract%20live%20music%20stage%20concept%20with%20soft%20glow%20and%20grain%20texture%20on%20cream%20background%2C%20editorial%20minimal%20style&width=800&height=600&seq=kanliao-topic-09&orientation=landscape",
    tags: ["乐队", "巡演", "现场"],
    heat: 6120,
    saved: 476,
    date: "2026-09-07",
    source: "看料编辑部",
  },
  {
    id: "t10",
    title: "通勤穿搭公式走红，简单三件套如何搭出高级感",
    summary:
      "不靠复杂叠穿，也能显得利落。我们从颜色比例、面料与版型三个角度，拆解了这一套被反复收藏的通勤搭配。",
    category: "时尚潮流",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cream%20background%20with%20abstract%20minimal%20wardrobe%20flat%20lay%20and%20muted%20coral%20accent%2C%20soft%20natural%20light%2C%20editorial%20magazine%20aesthetic&width=800&height=600&seq=kanliao-topic-10&orientation=landscape",
    tags: ["通勤", "穿搭", "公式"],
    heat: 5890,
    saved: 921,
    date: "2026-09-06",
    source: "看料编辑部",
  },
  {
    id: "t11",
    title: "短剧出海观察：中式叙事怎么打动海外观众",
    summary:
      "节奏快、钩子密是共性，但真正被反复观看的仍然是情感落点。我们整理了几部有代表性的作品与观众评论。",
    category: "网络热议",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20coral%20and%20gold%20abstract%20global%20concept%20with%20concentric%20circles%20on%20cream%20paper%20background%2C%20editorial%20minimal%20style&width=800&height=600&seq=kanliao-topic-11&orientation=landscape",
    tags: ["短剧", "出海", "观察"],
    heat: 7050,
    saved: 588,
    date: "2026-09-06",
    source: "看料编辑部",
  },
  {
    id: "t12",
    title: "电影节红毯观察：镜头之外的秩序与细节",
    summary:
      "红毯只有几分钟，背后却是精确到秒的流程。我们从采访区、合影位与补妆区三个角度，记录了一场红毯的完整动线。",
    category: "明星行程",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20amber%20and%20coral%20abstract%20red%20carpet%20event%20concept%20with%20soft%20spotlight%20on%20cream%20background%2C%20editorial%20minimal%20aesthetic&width=800&height=600&seq=kanliao-topic-12&orientation=landscape",
    tags: ["红毯", "电影节", "现场"],
    heat: 6680,
    saved: 545,
    date: "2026-09-05",
    source: "看料编辑部",
  },
];